import { useState } from 'react';

import { useChangePassword } from '@/api/queries';
import { Modal } from '@/ui/Modal';
import { FormError } from '@/ui/StateCard';
import { ActionButton, buttonState } from '@/ui/ActionButton';

export function ChangePasswordDialog({ onClose }: { onClose: () => void }) {
  const change = useChangePassword();
  const [current, setCurrent] = useState('');
  const [next, setNext] = useState('');
  const [confirm, setConfirm] = useState('');
  const mismatch = confirm.length > 0 && confirm !== next;

  if (change.isSuccess) {
    return (
      <Modal
        title="Password changed"
        size="narrow"
        onClose={onClose}
        footer={
          <button type="button" className="btn btn-primary" onClick={onClose}>
            Done
          </button>
        }
      >
        <p className="hint">Your other sessions have been signed out. This one stays signed in.</p>
      </Modal>
    );
  }

  return (
    <Modal
      title="Change password"
      subtitle="At least 10 characters, mixing letters with digits or symbols."
      size="narrow"
      onClose={onClose}
      onSubmit={() => !mismatch && change.mutate({ current_password: current, new_password: next })}
      footer={
        <>
          <button type="button" className="btn btn-secondary" onClick={onClose}>
            Cancel
          </button>
          <ActionButton state={buttonState(change)} label="Change password" disabled={mismatch || !next} />
        </>
      }
    >
      <div className="stack-md">
        <FormError error={change.error} />
        <div className="field">
          <label htmlFor="pw-current">Current password</label>
          <input id="pw-current" type="password" autoComplete="current-password" required value={current} onChange={(e) => setCurrent(e.target.value)} />
        </div>
        <div className="field">
          <label htmlFor="pw-new">New password</label>
          <input id="pw-new" type="password" autoComplete="new-password" required value={next} onChange={(e) => setNext(e.target.value)} />
        </div>
        <div className="field">
          <label htmlFor="pw-confirm">Confirm new password</label>
          <input
            id="pw-confirm"
            type="password"
            autoComplete="new-password"
            required
            className={mismatch ? 'has-error' : undefined}
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
          />
          {mismatch && <span className="field-error">The two passwords differ.</span>}
        </div>
      </div>
    </Modal>
  );
}
